import { httpClient } from '@/services/http/httpClient'

import type { DataType, Recurrence } from '@/tabs/shared/financialImpact/types'

export type CalculateROIRealTimeProps = {
  investment: number
  investmentRecurrence: Recurrence | null
  revenueGain: number
  revenueRecurrence: Recurrence | null
  costReduction: number
  costReductionRecurrence: Recurrence | null
  dataType: DataType
  periodMonths: number
}

export type CalculateROIRealTimeResponse = {
  roi: number
}

export const calculateRoiRealTime = async ({
  investment,
  investmentRecurrence,
  revenueGain,
  revenueRecurrence,
  costReduction,
  costReductionRecurrence,
  dataType,
  periodMonths,
}: CalculateROIRealTimeProps) => {
  const { data } = await httpClient.post<CalculateROIRealTimeResponse>(
    '/ideas/financial-details/calculate-roi-real-time',
    {
      investment,
      investmentRecurrence,
      revenueGain,
      revenueRecurrence,
      costReduction,
      costReductionRecurrence,
      dataType,
      periodMonths,
    },
  )
  return data
}
